<template>
  <div
    class="org-card bg-white dark:bg-slate-900 rounded-2xl p-5 shadow-sm hover:shadow-lg transition-all duration-300 border border-slate-100 dark:border-slate-800 flex items-start gap-4 cursor-pointer group"
    :class="{ 'electron-org-card': isElectron }"
    @click="jumpOrgPage"
  >
    <!-- Logo -->
    <div class="w-16 h-16 rounded-xl border border-slate-100 dark:border-slate-700 p-1 shrink-0 bg-white dark:bg-slate-800 overflow-hidden">
      <img :src="handleOrgLogo" :alt="orgInfo.org_name" class="w-full h-full object-cover rounded-lg" />
    </div>

    <!-- Info -->
    <div class="flex-1 min-w-0">
      <h3 class="font-bold text-slate-800 dark:text-white text-base mb-1 group-hover:text-brand-600 dark:group-hover:text-brand-400 transition-colors truncate">
        {{ orgInfo.org_name }}
      </h3>
      <p class="text-xs text-slate-500 dark:text-slate-400 leading-relaxed line-clamp-2 mb-2">
        {{ orgInfo.org_desc || '暂无简介' }}
      </p>
    </div>
  </div>
</template>

<script>
import { getCdnUrl } from "@saas/components/src";
export default {
  props: {
    orgInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      isElectron: window.isElectron,
    };
  },
  methods: {
    jumpOrgPage() {
      this.$router.push(`/org/${this.orgInfo.org_id}`);
    },
  },
  computed: {
    handleOrgLogo() {
      if (this.orgInfo?.org_logo) {
        return this.orgInfo.org_logo + "?imageView2/0/w/100";
      } else {
        return getCdnUrl("/cdn/static/images/default_org_logo.png", "?imageView2/0/w/100", "comettech");
      }
    },
  },
};
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Electron fixed width to match old behavior */
.org-card.electron-org-card {
  width: 310px;
}
</style>
